import { type Namespace } from 'i18next';

export const authI18n = ['auth', 'common'] satisfies Namespace;
